import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=ed0bb2d0&scoped=true"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"
import style0 from "./newsDetails.vue?vue&type=style&index=0&id=ed0bb2d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0bb2d0",
  null
  
)

export default component.exports